(function () {
  'use strict';

  function init() {
    // Header scroll effect
    var header = document.getElementById('main-header');
    if (header) {
      var onScroll = function () {
        if (window.scrollY > 50) {
          header.classList.add('border-gray-100', 'shadow-sm');
          header.classList.remove('border-transparent');
        } else {
          header.classList.remove('border-gray-100', 'shadow-sm');
          header.classList.add('border-transparent');
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Mobile menu toggle (with icon swap, aria state, close on link tap / Escape)
    var menuBtn = document.getElementById('mobile-menu-btn');
    var mobileMenu = document.getElementById('mobile-menu');
    if (menuBtn && mobileMenu) {
      var menuIcon = menuBtn.querySelector('.material-symbols-outlined');
      var setMenu = function (open) {
        mobileMenu.classList.toggle('hidden', !open);
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (menuIcon) menuIcon.textContent = open ? 'close' : 'menu';
      };
      menuBtn.addEventListener('click', function () {
        setMenu(mobileMenu.classList.contains('hidden'));
      });
      mobileMenu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { setMenu(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setMenu(false);
      });
    }

    // Scroll reveal effect
    var revealElements = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window) {
      var revealOnScroll = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('active');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
      revealElements.forEach(function (el) { revealOnScroll.observe(el); });
      // Reveal the first couple of blocks immediately
      setTimeout(function () {
        revealElements.forEach(function (el, index) {
          if (index < 2) el.classList.add('active');
        });
      }, 100);
    } else {
      revealElements.forEach(function (el) { el.classList.add('active'); });
    }

    // FAQ accordion (visual state + aria-expanded)
    var faqBtns = document.querySelectorAll('.faq-btn');
    var closeFaqItem = function (item) {
      var c = item.querySelector('.faq-content');
      if (c) c.classList.add('hidden');
      var i = item.querySelector('.faq-icon');
      if (i) { i.classList.remove('rotate-180', 'text-primary'); i.classList.add('text-gray-400'); }
      var n = item.querySelector('.faq-num');
      if (n) { n.classList.remove('text-primary'); n.classList.add('text-gray-400'); }
      var t = item.querySelector('.faq-title');
      if (t) t.classList.remove('font-bold');
      var b = item.querySelector('.faq-btn');
      if (b) b.setAttribute('aria-expanded', 'false');
      item.classList.remove('shadow-md');
      item.classList.add('shadow-sm');
    };
    faqBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parent = btn.closest('.faq-item');
        if (!parent) return;
        var content = parent.querySelector('.faq-content');
        var icon = btn.querySelector('.faq-icon');
        var num = btn.querySelector('.faq-num');
        var title = btn.querySelector('.faq-title');
        if (!content) return;
        var isOpen = !content.classList.contains('hidden');

        document.querySelectorAll('.faq-item').forEach(function (item) {
          if (item !== parent) closeFaqItem(item);
        });

        if (isOpen) {
          closeFaqItem(parent);
        } else {
          content.classList.remove('hidden');
          if (icon) { icon.classList.add('rotate-180', 'text-primary'); icon.classList.remove('text-gray-400'); }
          if (num) { num.classList.add('text-primary'); num.classList.remove('text-gray-400'); }
          if (title) title.classList.add('font-bold');
          btn.setAttribute('aria-expanded', 'true');
          parent.classList.add('shadow-md');
          parent.classList.remove('shadow-sm');
        }
      });
    });

    // Video modal (lazy iframe: loads only when opened, cleared on close)
    var lastVideoTrigger = null;
    var openVideoModal = function (modal, trigger) {
      var iframe = modal.querySelector('[data-video-iframe]');
      var src = modal.getAttribute('data-video-src');
      if (iframe && src) iframe.src = src;
      modal.classList.remove('hidden');
      modal.classList.add('open');
      document.body.classList.add('modal-open');
      lastVideoTrigger = trigger || null;
      var closeBtn = modal.querySelector('button[data-video-close]');
      if (closeBtn) closeBtn.focus();
    };
    var closeVideoModal = function (modal) {
      modal.classList.add('hidden');
      modal.classList.remove('open');
      document.body.classList.remove('modal-open');
      var iframe = modal.querySelector('[data-video-iframe]');
      if (iframe) iframe.src = 'about:blank';
      if (lastVideoTrigger && typeof lastVideoTrigger.focus === 'function') lastVideoTrigger.focus();
      lastVideoTrigger = null;
    };
    document.querySelectorAll('[data-video-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modal = document.getElementById(btn.getAttribute('data-video-open'));
        if (modal) openVideoModal(modal, btn);
      });
    });
    document.querySelectorAll('.video-modal').forEach(function (modal) {
      modal.querySelectorAll('[data-video-close]').forEach(function (el) {
        el.addEventListener('click', function () { closeVideoModal(modal); });
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.video-modal.open').forEach(function (modal) {
        closeVideoModal(modal);
      });
    });

    // Mobile sticky buy bar: appears after scrolling past the hero,
    // hides while the footer is in view
    var stickyCta = document.getElementById('sticky-cta');
    if (stickyCta) {
      var siteFooter = document.querySelector('footer');
      var onStickyScroll = function () {
        var show = window.scrollY > 500;
        if (show && siteFooter && siteFooter.getBoundingClientRect().top < window.innerHeight) {
          show = false;
        }
        stickyCta.classList.toggle('visible', show);
        stickyCta.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      window.addEventListener('scroll', onStickyScroll, { passive: true });
      onStickyScroll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
